<template>
  <MenuItem :key="itemKey">
    <span class="flex items-center">
      <span style="padding-right:8px;display: inline-block;padding-left: 0" v-if="userIconFlag" :class="userIcon"></span>
      <Icon v-if="!svgIconFlag&&!userIconFlag" :icon="icon" class="mr-1"/>
       <SvgIcon style="display: inline-block;margin-right: 6px;" v-if="svgIconFlag" :name="icon"/>
      <span>{{ text }}</span>
    </span>
  </MenuItem>
</template>
<script lang="ts">
import {Menu} from 'ant-design-vue';
import {SvgIcon} from '@/components/Icon';
import {computed, defineComponent, getCurrentInstance} from 'vue';

import Icon from '@/components/Icon/index';
import {propTypes} from '@/utils/propTypes';

export default defineComponent({
  name: 'DropdownMenuItem',
  components: {MenuItem: Menu.Item, Icon,SvgIcon},
  props: {
    svgIconFlag: {
      type: Boolean,
      default: false
    },
    userIconFlag:{
      type: Boolean,
      default: false
    },
    userIcon:propTypes.string,
    // eslint-disable-next-line
    key: propTypes.string,
    text: propTypes.string,
    icon: propTypes.string,
  },
  setup(props) {
    const instance = getCurrentInstance();
    const itemKey = computed(() => props.key || instance?.vnode?.props?.key);
    return {itemKey};
  },
});
</script>
